import styled from "styled-components";
import { fHeader } from "../../styles/global";

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 7.5rem;
  pointer-events: none;
  z-index: 1;
  @media (max-width: 1023px) {
    padding-top: 1.5rem;
  }
  @media (max-width: 767px) {
    padding-top: 0rem;
  }
`;

export const Inner = styled.div`
  position: relative;
  z-index: 2;
  padding: 1.8rem 10% 1.6rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  ${fHeader};
  pointer-events: auto;
  background: white;
  &:after {
    content: "";
    position: absolute;
    left: 10%;
    bottom: 0;
    display: block;
    width: 80%;
    height: 1px;
    background: black;
  }
  @media (max-width: 767px) {
    width: auto;
    padding-left: 3rem;
    padding-right: 8rem;
    &:after {
      left: 3rem;
      right: 3rem;
      width: auto;
    }
  }

  button {
    padding: 0;
    border: 0;
    font: inherit;
    letter-spacing: inherit;
    line-height: inherit;
    cursor: pointer;
    outline: none;
  }

  a:hover,
  button:hover {
    opacity: 0.5;
  }
`;

export const SiteTitle = styled.div`
  text-transform: uppercase;
`;

export const WorksToggle = styled.button`
  background: transparent;
  opacity: ${(props) => (props.selected ? 0.5 : 1)};
`;

export const Works = styled.div`
  position: relative;
  z-index: 1;
  width: 80%;
  margin: 0 auto;
  border-bottom: 1px solid black;
  padding: 1.7rem 0;
  background: white;
  transform: translateY(${(props) => (props.open ? 0 : -5)}px);
  opacity: ${(props) => (props.open ? 1 : 0)};
  visibility: ${(props) => (props.open ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.open ? "auto" : "none")};
  transition: opacity 0.3s cubic-bezier(0.215, 0.61, 0.355, 1),
    transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1),
    visibility 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  @media (max-width: 767px) {
    width: auto;
    margin-left: 3rem;
    margin-right: 3rem;
  }

  ul {
    column-count: 3;
    column-gap: 3.2rem;
    @media (max-width: 1150px) {
      column-count: 2;
    }
    @media (max-width: 767px) {
      column-count: 1;
      line-height: 1.5;
    }
  }

  li {
    text-indent: -1em;
    padding-left: 1em;
  }

  a:hover,
  button:hover {
    opacity: 0.5;
  }
`;

export const Navigation = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
`;

export const NavigationToggle = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 1.6rem;
  border: 0;
  font: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  cursor: pointer;
  outline: none;
  color: ${(props) => (props.open ? "white" : "inherit")};
  ${"" /* transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1); */}
  background: none;

  @media (max-width: 767px) {
    right: 1.4rem;
  }

  &:hover {
    opacity: 0.5;
  }

  line:nth-child(2) {
    transform: ${(props) => (props.open ? "rotate(-45deg)" : "rotate(0deg)")};
    transform-origin: center;
  }

  line:nth-child(3) {
    transform: ${(props) => (props.open ? "rotate(45deg)" : "rotate(0deg)")};
    transform-origin: center;
    visibility: ${(props) => (props.open ? "visible" : "hidden")};
  }

  line:nth-child(1),
  line:nth-child(4) {
    visibility: ${(props) => (props.open ? "hidden" : "visible")};
  }

  svg {
    display: block;
    width: 2.8rem;
    height: 2.8rem;
    fill: none;
    stroke-width: 1.25;
    stroke: currentColor;
  }
`;

export const NavigationDrawer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 290px;
  height: 100vh;
  padding: 15rem 3.6rem;
  background: rgba(0, 0, 0, 1);
  color: white;
  ${"" /* transform: translateX(${props => (props.open ? 0 : 15)}px); */}
  opacity: ${(props) => (props.open ? 1 : 0)};
  visibility: ${(props) => (props.open ? "visible" : "hidden")};
  ${"" /* transition: opacity 0.2s cubic-bezier(0.215, 0.61, 0.355, 1),
    transform 0.2s cubic-bezier(0.215, 0.61, 0.355, 1),
    visibility 0.2s cubic-bezier(0.215, 0.61, 0.355, 1); */}
  transition: opacity 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  @media (max-width: 480px) {
    padding: 3rem 4rem;
  }

  div {
    margin-bottom: 0.15em;
  }

  a {
    ${fHeader};
    line-height: 1.35;

    &.active {
      ${"" /* background-image: linear-gradient(
        to right,
        currentColor 100%,
        currentColor 0
      );
      background-size: 1px 1px;
      background-position: 0 0.89em;
      background-repeat: repeat-x; */}

      opacity: 0.5;
    }

    &:hover {
      opacity: 0.5;
    }
  }
`;
